export const pageTitle = 'roboto-custom-black fw-bold';
export const whiteCard = 'p-main bg-white p-3 ';
export const borderRadius = ' mainRaduis ';
export const noDataCard = 'p-main bg-white border-15 p-3 h-100 text-center';
export const pageTitleShow = 'col-lg-9 col-md-9 col-sm-12  bold rtl capatalise mb-main';
export const pageTitleAuction = 'col-lg-6 col-md-6 col-sm-12  bold rtl capatalise mb-main';
export const btnContainerShow = 'col-lg-3 col-md-3 col-sm-12  bold rtl capatalise mb-main ms-auto';
export const btnContainerAuction = 'col-lg-6 col-md-6 col-sm-12  bold rtl capatalise mb-main ms-auto';
export const termsTitle = 'col-sm-12  bold rtl capatalise';
export const showIconsContainer = 'col-md-12 col-sm-12 row mb-main rtl';
export const iconContainer = 'col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-1';
export const serviceRequestHeadContainer = 'row rtl';
export const serviceRequestTitle = 'text-start fw-bold col-xl-8 col-lg-6 col-md-12 col-sm-12 col-12 mb-main';
export const userDropDown = 'text-start fw-bold col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12 hideLabel mb-main';
export const eformInput = 'col-md-6 col-sm-12 col-12 mb-form-group'
export const eformCheckBox = 'col-md-3 col-sm-6 col-6 mb-form-group'
export const eformTerms = 'col-sm-12 col-12 mb-form-group horseCardDescription'
export const eformFormButton = 'col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 ms-3 mb-md-0 mb-sm-2 mb-2'
export const eformApproveAndPay = 'col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 ms-3 mb-md-0 mb-sm-2 mb-2'
export const eFormButtonsContainer = 'col-md-12 col-sm-12 d-flex justify-content-end flex-wrap'
export const saveBtnInProfile = 'col-md-2 col-sm-4 col-4 ms-auto mt-2 px-0'
export const wahoCard = 'col-lg-3 col-md-4 col-sm-6 col-12 mb-main'
export const wahoCardWithImg = 'col-lg-4 col-md-4 col-sm-6 col-12 mb-main me-3'
export const wahoCardBg = 'p-main border-15 p-3 h-100 border borderf3 homeWhiteBg'
export const filterResponsive = "col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 mb-main"
export const rightResponsive = "col-xl-9 col-lg-8 col-md-6 col-sm-12 col-12 mb-main"
export const studCardContainer = "col-xl-4 col-lg-6 col-md-12 col-sm-12 col-12 mb-main rtl"
export const filterContainer = "p-main bg-white border-15 p-3"
export const filterCard = "p-main bg-white border-15 p-3"
export const filterHeader = "text-start fw-bold fz-26"
export const filterButtonsContainer = "row mt-10"
export const filterResetBtn = "col-xl-6 col-lg-12 col-md-12 mb-xl-0 mb-lg-3 mb-3"
export const filterSubmitBtn = "col-xl-6 col-lg-12 col-md-12 mb-0"
export const aedLogoStyle = { height: 12, marginBottom: 4 };
const BaseURL = process.env.REACT_APP_BASE_URL;
export const getDirhamImage = (lang) => {
    if (lang == "en") {
        return `${BaseURL}/assets/svg/aed.svg`
    } else {
        return `${BaseURL}/assets/svg/aedar.svg`
    }
}
